



import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Select,
  Button,
  Typography,
  Box,
  Grid,
  FormControl,
  InputLabel,
  Stack,
} from "@mui/material";

const CreateSubcategory = ({ open, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    businessType: "",
    category: "",
    subcategoryName: "",
    subcategoryType: "",
    description: "",
    image: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, image: file }));
  };

  const handleSubmit = () => {
    onSave(formData); // send data back to parent
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add A Sub Category</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={3} mt={1}>
          {/* Business Type */}
          <FormControl fullWidth>
            <InputLabel>Business Type</InputLabel>
            <Select
              name="businessType"
              value={formData.businessType}
              onChange={handleChange}
              label="Business Type"
            >
              <MenuItem value="Retail">Retail</MenuItem>
              <MenuItem value="Service">Service</MenuItem>
            </Select>
          </FormControl>

          {/* Category */}
          <FormControl fullWidth>
            <InputLabel>Category</InputLabel>
            <Select
              name="category"
              value={formData.category}
              onChange={handleChange}
              label="Category"
            >
              <MenuItem value="Electronics">Electronics</MenuItem>
              <MenuItem value="Fashion">Fashion</MenuItem>
            </Select>
          </FormControl>

          {/* Subcategory Name */}
          <TextField
            fullWidth
            label="Sub Category Name"
            name="subcategoryName"
            value={formData.subcategoryName}
            onChange={handleChange}
          />

          {/* Subcategory Type */}
          <FormControl fullWidth>
            <InputLabel>Sub Category Type</InputLabel>
            <Select
              name="subcategoryType"
              value={formData.subcategoryType}
              onChange={handleChange}
              label="Sub Category Type"
            >
              <MenuItem value="Physical">Physical</MenuItem>
              <MenuItem value="Digital">Digital</MenuItem>
            </Select>
          </FormControl>

          {/* Description */}
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Description"
            name="description"
            value={formData.description}
            onChange={handleChange}
          />

          {/* Upload Image */}
          <Box>
            <Typography variant="subtitle1" mb={1}>
              Upload Image
            </Typography>
            <Button variant="outlined" component="label">
              Choose File
              <input type="file" hidden onChange={handleImageUpload} />
            </Button>
            {formData.image && (
              <Typography variant="body2" mt={1}>
                {formData.image.name}
              </Typography>
            )}
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} color="error" variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          + Create Subcategory
        </Button>
      </DialogActions>
    </Dialog>);
};

export default CreateSubcategory;
